import shopifyGenericDefaults from '../shopify-generic/config.js';

const engineFields = ['engine_duty', 'engine_brand', 'engine_label'];

function InitFunc() {
  shopifyGenericDefaults.InitFunc();

  const searchPage = window.document.querySelector('#cm_results');
  searchPage?.closest('.page-content')?.classList.remove('rte', 'page-content');
  searchPage?.closest('.section-main-page')?.classList.remove('section-main-page');
}

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  InitFunc,
  product: {
    ...shopifyGenericDefaults.product,
    noImageSrc: window.Convermax?.config?.noImageSrc || 'https://client.convermax.com/static/img/noimage.png',
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter((w) => w.name !== 'SearchBoxHero').map((widget) =>
      widget.type === 'FacetPanel'
        ? {
            ...widget,
            ignoreFields: [...(widget.ignoreFields || []), ...engineFields],
          }
        : widget,
    ),
    {
      name: 'EnginePanel_search',
      type: 'RequestPanel',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: engineFields,
      requiredFields: engineFields,
      discardVehicleOnSubmit: true,
      isAutoRedirectDisabled: true,
      autoOpenDropdowns: 'next',
      redirectUrl: '/pages/search-by-engine',
      visibleIf: () => window.location.pathname === '/pages/search-by-engine',
    },
    {
      name: 'EnginePanel_tab',
      type: 'RequestPanel',
      location: '#cm-engine-tab',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: engineFields,
      requiredFields: engineFields,
      localStorageKey: 'cm_engine-search',
      shouldBeIsolated: () => true,
      mayDiscardIsolatedSelection: true,
      discardVehicleOnSubmit: true,
      isAutoRedirectDisabled: true,
      autoOpenDropdowns: 'next',
      redirectUrl: '/pages/search-by-engine',
    },
    {
      name: 'SearchBoxHero',
      type: 'SearchBox',
      location: { replace: '.dh-tool.cm-search-box', id: 'cm-search-box-hero', class: 'cm-search-box' },
      searchBoxPlaceholderText: 'Enter part number...',
      template: 'SearchBoxHero',
    },
  ],
};
